function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import SyntaxHighlighter from "react-syntax-highlighter/dist/light";
import style from 'react-syntax-highlighter/dist/styles/github';

var CodeHighlight = function (_React$PureComponent) {
  _inherits(CodeHighlight, _React$PureComponent);

  function CodeHighlight() {
    _classCallCheck(this, CodeHighlight);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  CodeHighlight.prototype.render = function render() {
    return React.createElement(
      SyntaxHighlighter,
      { style: style, language: this.props.language },
      this.props.children.length ? this.props.children[0] : ''
    );
  };

  return CodeHighlight;
}(React.PureComponent);

CodeHighlight.defaultProps = {
  children: []
};

CodeHighlight._idyll = {
  name: "CodeHighlight",
  tagType: "open",
  children: ['var x = 1;'],
  props: [{
    name: "language",
    type: "string",
    example: "javascript"
  }]
};
export default CodeHighlight;